import api from "./api";

class ReportLogRequest {

    #url = process.env.REACT_APP_API_URL + "/report-log";

    #resend_uri = "/resend";

    async reSendData(data) {
        const resp = await api.post(this.#url + this.#resend_uri, data);
        return resp.data;
    }
}

export default new ReportLogRequest();